import date from "@/utils/date";
import * as turf from "@turf/turf";

const capitalize = (str) => {
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

const formatMoney = (input, offset = 1) => {
  if (!Number.isFinite(input)) return (0).toFixed(0);

  if (Math.abs(input / offset) > 1000000000) {
    return (input / 1000000000).toFixed(1) + "B";
  } else if (Math.abs(input / offset) > 1000000) {
    return (input / 1000000).toFixed(1) + "M";
  } else if (Math.abs(input / offset) > 1000) {
    return (input / 1000).toFixed(1) + "K";
  } else {
    return input.toFixed(0);
  }
};

const parseTime = (input) => {
  let time = parseInt(input.replace(":", ""));

  time = Math.floor(time / 5) * 5;

  return time;
};

const timeArray = (time) => {
  return [
    Math.floor(time / 100)
      .toString()
      .padStart(2, "0"),
    (time % 100).toString().padStart(2, "0"),
  ];
};

const displayTime = (time) => {
  return (
    Math.floor(time / 100)
      .toString()
      .padStart(2, "0") +
    ":" +
    (time % 100).toString().padStart(2, "0")
  );
};

const displayChatTimestamp = (time) => {
  if (!(time instanceof Date)) time = new Date(time);

  // console.log(time);

  if (date.diff(new Date(), time, "hours") < 3) {
    return date.format(time, "HH:mm");
  } else if (date.diff(new Date(), time, "hours") < 48) {
    return "Yesterday " + date.format(time, "HH:mm");
  } else if (date.diff(new Date(), time, "days") < 6) {
    return date.format(time, "dddd HH:mm");
  } else if (date.diff(new Date(), time, "months") < 6) {
    return date.format(time, "DD MMM, HH:mm");
  } else {
    return date.format(time, "DD MMM YYYY, HH:mm");
  }
};

const displayPostTimestamp = (time) => {
  if (!(time instanceof Date)) time = new Date(time);

  // console.log(
  //   date.diff(date.zeroUTCtime(new Date()), date.zeroUTCtime(time), "days")
  // );

  if (date.diff(new Date(), time, "hours") < 0) {
    if (
      date.diff(date.zeroUTCtime(new Date()), date.zeroUTCtime(time), "days") ==
      0
    ) {
      return "Today " + date.format(time, "HH:mm", true);
    } else if (
      date.diff(date.zeroUTCtime(new Date()), date.zeroUTCtime(time), "days") ==
      -1
    ) {
      return "Tomorrow " + date.format(time, "HH:mm", true);
    } else {
      return date.format(time, "DD MMM YYYY, HH:mm", true);
    }
  } else {
    if (
      date.diff(date.zeroUTCtime(new Date()), date.zeroUTCtime(time), "days") ==
      0
    ) {
      return "Today " + date.format(time, "HH:mm", true);
    } else if (
      date.diff(date.zeroUTCtime(new Date()), date.zeroUTCtime(time), "days") ==
      1
    ) {
      return "Yesterday " + date.format(time, "HH:mm", true);
    } else if (date.diff(new Date(), time, "days") < 6) {
      return date.format(time, "dddd HH:mm", true);
    } else if (date.diff(new Date(), time, "months") < 6) {
      return date.format(time, "DD MMM, HH:mm", true);
    } else {
      return date.format(time, "DD MMM YYYY, HH:mm", true);
    }
  }
};

const printBalance = (value) => {
  if (Math.abs(value) < 1000) {
    return value;
  } else if (Math.abs(value) < Math.pow(10, 6)) {
    return (value / 1000).toFixed(1) + "k";
  } else {
    return (value / Math.pow(10, 6)).toFixed(1) + "M";
  }
};

const parseDuration = (input) => {
  return parseInt(input.split(":")[0]) * 60 + parseInt(input.split(":")[1]);
};

const displayDuration = (time, inSeconds = false) => {
  if (time < 0) {
    return inSeconds ? "00:00:00" : "00:00";
  }

  time = Math.round(time);

  if (inSeconds) {
    return (
      Math.floor(time / 3600)
        .toString()
        .padStart(2, "0") +
      ":" +
      Math.floor((time % 3600) / 60)
        .toString()
        .padStart(2, "0") +
      ":" +
      Math.floor(time % 60)
        .toString()
        .padStart(2, "0")
    );
  } else {
    return (
      Math.floor(time / 60)
        .toString()
        .padStart(2, "0") +
      ":" +
      (time % 60).toString().padStart(2, "0")
    );
  }
};

const calcDuration = (dep, arr, cruiseTAS) => {
  const depLoc = turf.point([dep.location.lon, dep.location.lat]);
  const arrLoc = turf.point([arr.location.lon, arr.location.lat]);
  const dist = turf.distance(arrLoc, depLoc) * 0.539956803;

  // console.log(dist);

  return Math.max(30, Math.round((dist / cruiseTAS) * 1.1 * 12) * 5 + 25);
};

const displayDateSmart = (input, includeYear = false, includeMonth = true) => {
  if (!(input instanceof Date)) input = new Date(input);

  const weekday = includeYear ? "" : " ddd";
  const month = includeMonth ? " MMM" : "";
  const year = includeYear ? " YYYY" : "";

  if (
    date.diff(date.zeroUTCtime(new Date()), date.zeroUTCtime(input), "days") ==
    0
  ) {
    return "Today, " + date.format(input, "HH:mm", true);
  } else if (
    date.diff(date.zeroUTCtime(new Date()), date.zeroUTCtime(input), "days") ==
    1
  ) {
    return "Yesterday, " + date.format(input, "HH:mm", true);
  } else {
    return date.format(input, `HH:mm,${weekday} DD${month}${year}`, true);
  }
};

const displayDateSmartWithoutTime = (
  input,
  includeYear = true,
  includeMonth = true,
) => {
  if (!(input instanceof Date)) input = new Date(input);

  const weekday = includeYear ? "" : "ddd";
  const month = includeMonth ? " MMM" : "";
  const year = includeYear ? " YYYY" : "";

  if (
    date.diff(date.zeroUTCtime(new Date()), date.zeroUTCtime(input), "days") ==
    0
  ) {
    return "Today";
  } else if (
    date.diff(date.zeroUTCtime(new Date()), date.zeroUTCtime(input), "days") ==
    1
  ) {
    return "Yesterday";
  } else {
    return date.format(input, `${weekday} DD${month}${year}`, true);
  }
};

const findFirstDate = (weekDay, time) => {
  let startDate = new Date();

  // console.log(date.format(startDate, "YYYY-MM-DD HH:mm", true));

  startDate.setUTCHours(timeArray(time)[0]);
  startDate.setUTCMinutes(timeArray(time)[1]);
  startDate.setUTCSeconds(0);

  // console.log(date.format(startDate, "YYYY-MM-DD HH:mm", true));
  while (
    date.format(startDate, "ddd", true).toLowerCase() !=
      weekDay.toLowerCase() ||
    startDate < date.add(new Date(), 1, "hours")
  ) {
    startDate = date.add(startDate, 24, "hours");
  }

  // console.log(date.format(startDate, "YYYY-MM-DD HH:mm", true));
  return date.format(startDate, "YYYY-MM-DD HH:mm", true);
};

const weekDayToShort = (day) => {
  switch (day) {
    case "mon":
      return "Mo";
    case "tue":
      return "Tu";
    case "wed":
      return "We";
    case "thu":
      return "Th";
    case "fri":
      return "Fr";
    case "sat":
      return "Sa";
    case "sun":
      return "Su";
  }
};

const find10minutes = () => {
  let startDate = date.add(new Date(), 13, "minute");
  startDate.setUTCMinutes(Math.ceil(startDate.getUTCMinutes() / 5) * 5);

  return date.format(startDate, "HH:mm", true);
};

const find20minutes = () => {
  let startDate = date.add(new Date(), 23, "minute");
  startDate.setUTCMinutes(Math.ceil(startDate.getUTCMinutes() / 5) * 5);

  return date.format(startDate, "HH:mm", true);
};

const timeDiff = (date1, date2, unit) => {
  return date.diff(date1, date2, unit);
};

const getRandomInt = (min, max) => {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

const formatLatitude = (lat) => {
  return `${Math.abs(lat).toFixed(5)}°${lat > 0 ? "N" : "S"}`;
};

const formatLongitude = (lon) => {
  return `${Math.abs(lon).toFixed(5)}°${lon > 0 ? "E" : "W"}`;
};

const formatLocation = (location) => {
  return formatLatitude(location.lat) + " " + formatLongitude(location.lon);
};

const calcBrgDiff = (b1, b2) => {
  let angle = (b2 - b1) % 360;
  if (angle < -180) angle += 360;
  if (angle >= 180) angle -= 360;
  return angle;
};

const formatTime = (dateText) => {
  if (dateText === null) return "N/A";
  if (!(dateText instanceof Date)) dateText = new Date(dateText);
  return date.format(dateText, "HH:mm", true) + "z";
};

const ratingColor = (rating) => {
  if (rating >= 8) {
    return "bg-positive text-white";
  }
  if (rating >= 6) {
    return "bg-info text-white";
  }
  if (rating >= 4) {
    return "bg-warning text-black";
  }
  return "bg-negative text-white";
};

const getEstimatedArrivalTime = (flight) => {
  const currentLoc = turf.point([
    flight.lastState.location.lon,
    flight.lastState.location.lat,
  ]);
  const arrLoc = turf.point([flight.arr.location.lon, flight.arr.location.lat]);

  const dist = turf.distance(currentLoc, arrLoc) * 0.539956803;

  // console.log(dist, flight.lastState.speed.gs);

  let remaining = dist / flight.lastState.speed.gs;

  return date.add(new Date(), remaining + 0.5, "hours");
};

const defaultPagination = (pagination) => {
  if (pagination === undefined)
    return {
      page: 1,
      rowsPerPage: 50,
      sortBy: "",
      descending: false,
    };
  if (pagination.page === undefined) pagination.page = 1;
  if (pagination.rowsPerPage === undefined) pagination.rowsPerPage = 50;
  if (pagination.sortBy === undefined) pagination.sortBy = null;
  if (pagination.descending === undefined) pagination.descending = false;
  return pagination;
};

import { useSettingsStore } from "@/store/settingsStore";

const getWeightUnits = () => {
  const settingsStore = useSettingsStore();

  return settingsStore.flightplanning.units.toLowerCase() == "lbs"
    ? "LBS"
    : "KGS";
};

const formatWeight = (weight, addUnits = false, inputUnits = "kgs") => {
  const settingsStore = useSettingsStore();

  if (weight == null) return null;

  if (weight == undefined) weight = 0;

  if (
    settingsStore.flightplanning.units.toLowerCase() == "lbs" &&
    inputUnits == "kgs"
  ) {
    weight = Math.round(weight * 2.2046226);
  }

  if (
    settingsStore.flightplanning.units.toLowerCase() == "kgs" &&
    inputUnits == "lbs"
  ) {
    weight = Math.round(weight / 2.2046226);
  }

  if (addUnits) {
    return (
      weight +
      (settingsStore.flightplanning.units.toLowerCase() == "lbs"
        ? " LBS"
        : " KGS")
    );
  } else {
    return weight;
  }
};

const printWeight = (profile, name, units, round = true) => {
  let result = 0;

  if (units === undefined) {
    result = profile.details[name];
  } else {
    units = units.toLowerCase().trim();

    if (units == "kgs") {
      result =
        profile.details[name] /
        (profile.details.wgtunits.toLowerCase() == "lbs" ? 2.2046226 : 1);
    }

    if (units == "lbs") {
      result =
        profile.details[name] *
        (profile.details.wgtunits.toLowerCase() == "lbs" ? 1 : 2.2046226);
    }
  }

  if (round) result = Math.round(result);

  return result;
};

const convertToKGS = (weight) => {
  return Math.round(weight / 2.2046226);
};

const convertToLBS = (weight) => {
  return Math.round(weight * 2.2046226);
};

const isJson = (input) => {
  let value = typeof input !== "string" ? JSON.stringify(input) : input;
  try {
    value = JSON.parse(value);
  } catch (e) {
    return false;
  }

  if (typeof value === "object" && value !== null) {
    return value;
  }

  return false;
};

import seedrandom from "seedrandom";

function seededRandomRange(min, max, seed = "") {
  let myrng = seedrandom(seed);
  const result = myrng();
  return result * (max - min) + min;
}

function randomEmoji(emots, message) {
  return emots[
    Math.round(
      seededRandomRange(
        0,
        emots.length - 1,
        date.format(new Date(message.createdAt), "YYYY-MM-DD HH:mm:ss", true),
      ),
    )
  ];
}

const downloadExport = (blob, filename) => {
  if (navigator.msSaveBlob) {
    // IE 10+
    navigator.msSaveBlob(blob, filename);
  } else {
    var link = document.createElement("a");
    if (link.download !== undefined) {
      // feature detection
      // Browsers that support HTML5 download attribute
      var url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", filename);
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
};

const urlQueryString = (obj) => {
  return new URLSearchParams(obj).toString();
};

export {
  capitalize,
  formatMoney,
  parseTime,
  displayTime,
  displayChatTimestamp,
  displayPostTimestamp,
  printBalance,
  parseDuration,
  displayDuration,
  calcDuration,
  displayDateSmart,
  displayDateSmartWithoutTime,
  findFirstDate,
  weekDayToShort,
  find10minutes,
  find20minutes,
  timeDiff,
  getRandomInt,
  formatLatitude,
  formatLongitude,
  formatLocation,
  calcBrgDiff,
  formatTime,
  ratingColor,
  getEstimatedArrivalTime,
  defaultPagination,
  getWeightUnits,
  formatWeight,
  printWeight,
  convertToKGS,
  convertToLBS,
  isJson,
  seededRandomRange,
  randomEmoji,
  downloadExport,
  urlQueryString,
};
